import { useSelector, shallowEqual } from 'react-redux';
import { checkAuth } from 'functions/checkAuth';

export const useAuth = () => useSelector(
  ({ authentication, profile, userGet }) => checkAuth(
    { authentication, profile, userGet },
  ),
  shallowEqual,
);
